import type { PartnerDto } from "../../../../api";
import { OrderAddressSection } from "../../../../components/common/order-address-section";

interface PurchaseOrderAddressProps {
  partner: PartnerDto | null | undefined;
  destAddress: PartnerDto | null | undefined;
}

export function PurchaseOrderAddress({
  partner,
  destAddress,
}: PurchaseOrderAddressProps) {
  return (
    <OrderAddressSection
      invoicePartner={partner ?? null}
      shippingPartner={null}
      destAddress={destAddress}
    />
  );
}
